package com.github.jangalinski.tabweb._foundation.alignment

data object END : Horizontal, CardinalDirection {
  val alignment = RIGHT.alignment
}
